export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-06.jpg'),
        title: 'ブロックチェーン',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '先進的な暗号化ストレージ技術',
      description: `<p style="font-size:1.05rem">ブロックチェーンは分散データ保存、ピアツーピア伝送、コンセンサス機構、暗号アルゴリズムなど、多様な用途に用いられる新しい計算技術です。ブロックチェーンシステムはオープンで独立しており、従来の「人への信頼」を「機械への信頼」に置き換えます。ブロックチェーンに保存されたデータは改ざん耐性があり信頼性が高いため、物流、金融、保険、公共サービスなど、複雑な連携と透明性を必要とする従来の業界課題を解決できます。ブロックチェーン技術は時間とコストを削減し、企業に新たな価値をもたらします。</p>`
    },
    {
      title: '私たちの強み',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-06.jpg')+`)"></span>
      <span>MaesInfoは高度な研究開発チームを擁し、最新のブロックチェーン技術を探求しています。長年のITサービス経験を活かして、ブロックチェーンに基づく新しいビジネスモデルの構築を支援します。業界の特性に応じたブロックチェーン統合ソリューション、技術支援、ビジネスプラン策定、エコシステム共同構築などを提供します。</span>`
    }
  ]
}
